import React from "react";
import RenderAuditStaticTables from "./renderAuditTables";

const ReadingAuditPrint = ({ id, instrumentId,DUCID }) => {
  return (
    <div>
      <div className="row">
        <RenderAuditStaticTables
          tableDisplayStatus={1}
          certificateId={id}
          instrumentId={instrumentId}
          deletedTableIds={null}
          tableDivide={false}
          DUCID={DUCID}
        />
      </div>
    </div>
  );
};

export default ReadingAuditPrint;
